module.exports = __webpack_public_path__ + "static/gari2-f8e1cdebcf0e961867bcb4931e8b1d0c.jpg";